import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FavoriteCardTypeEnum, UserFavoriteCardData } from '../../../user-favorite-data.model';
import { Currency } from '../../../../../model/landingModel';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { FavoriteSocialService } from '../../../favorite-social.service';

@Component({
  selector: 'transfers-card',
  template: `
    <div>
      <div class="heading-spacing">
      <card-header
        [showDeleteBtn]="showDeleteBtn"
        (onDeleteFavoriteClick)="onDeleteFavoriteClick.emit()"
        [externalId]="data.external_id"
        [product]="data.product"
        [flow]="flow"
      >
          <div>
            <div class="eva-3-h5">
              {{ data.main_text }}
            </div>
            <div class="eva-3-caption">
              {{ data.auxiliary_text }}
            </div>
          </div>
        </card-header>
      </div>
      <div>
        <div class="eva-3-offer-card">
          <div class="image-and-icons-section">
            <div class="car-img-section">
              <img class="car-image" srcset="{{ favImage }}" alt="" loading="lazy" />
            </div>
            <div class="icons-section">
              <fav-characteristics-icons [characteristics]="data.characteristics!" />
            </div>
          </div>

          <span *ngIf="data.outstanding_driver && cardType !== FavoriteCardTypeEnum.REDUCED" class="favorite-card-driver eva-3-driver offer-card-main-driver">
            <span class="driver-text">
              <fav-image [src]="driverImage" [cssClass]="'driver-image'"></fav-image>
              {{ data.outstanding_driver.text }}
            </span>
          </span>

          <div class="favorite-card-content-spacing"
            *ngIf="cardType !== FavoriteCardTypeEnum.REDUCED">
            <favorite-card-drivers [data]="data" [tooltipsPosition]="position === 0 ? 'right' : 'left' "></favorite-card-drivers>
          </div>

          <ul class="details -eva-3-pl-lg -eva-3-pr-lg -eva-3-pl-lg -eva-3-pr-lg -eva-3-pb-sm">
            <li *ngFor="let item of data.details" class="detail-item">
              <i class="eva-3-icon-{{ item.icon }}"></i>
              <span class="eva-3-caption">{{ item.text }}</span>
            </li>
          </ul>

          <div class="favorite-card-pricebox-section"
            *ngIf="cardType !== FavoriteCardTypeEnum.REDUCED">

            <favorite-card-pricebox
              [data]="data"
              [moduleId]="moduleId"
              [moduleIndex]="moduleIndex"
              [currency]="currency"
              [locale]="locale"
              [isWhiteLabel]="isWhiteLabel"
              [showAlertBtn]="showAlertBtn"
              [uniqueId]="uniqueId"
            ></favorite-card-pricebox>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['../common-styles.scss', './transfers-card.component.scss'],
})
export class TransfersCardComponent implements OnInit {
  @Input() data: UserFavoriteCardData;
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() isWhiteLabel: boolean;
  @Input() showAlertBtn: boolean;
  @Input() flow: string;
  @Input() showDeleteBtn: boolean;
  @Input() position: number;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDeleteFavoriteClick = new EventEmitter();
  @Input() cardType: FavoriteCardTypeEnum;

  favImage: string | undefined;
  driverImage: string | undefined;
  FavoriteCardTypeEnum = FavoriteCardTypeEnum;

  constructor(public mediaPictureService: MediaPictureService, private favoriteSocialService: FavoriteSocialService) {}

  ngOnInit(): void {
    this.favImage = this.favoriteSocialService.getFavImgSrcUrl(this.data.picture_link, this.cardType);

    if (this.data.outstanding_driver) {
      this.driverImage = this.mediaPictureService.getMediaUrl(this.data.outstanding_driver.icon_src);
    }
  }
}
